import { currencies as allCurrencies } from '../config/config';
import { Currency } from '../types/currency';
import { useLoanCalculator } from './hooks/useLoanCalculator';
import { CollateralRow } from './components/CollateralRow';
import { LoanAmountRow } from './components/LoanAmountRow';
import { LoanDetailsPanel } from './components/LoanDetailsPanel';
import { PeriodPills } from './components/PeriodPills';
import styles from './Calculator.module.less';

interface CalculatorProps {
  currency?: string;
}

export function Calculator({ currency }: CalculatorProps) {
  const calc = useLoanCalculator({ initialCurrency: currency });

  return (
    <div className={styles.calculator}>
      <div className={styles.inputs}>
        <LoanAmountRow
          value={calc.loanInput}
          currency={calc.currency}
          currencies={allCurrencies as Currency[]}
          loanBig={calc.loanBig}
          minLoan={calc.minLoan}
          maxLoan={calc.maxLoan}
          onValueChange={calc.onLoanInputChange}
          onBlur={calc.onLoanBlur}
          onSliderChange={calc.setLoanFromSlider}
          onCurrencyChange={calc.setCurrency}
        />
        <CollateralRow
          value={calc.collateralInput}
          collateralBig={calc.collateralBig}
          minBtc={calc.minBtc}
          maxBtc={calc.maxBtc}
          onValueChange={calc.onCollateralInputChange}
          onBlur={calc.onCollateralBlur}
          onSliderChange={calc.setCollateralFromSlider}
        />
        <PeriodPills value={calc.period} options={calc.periods} onChange={calc.setPeriod} />
      </div>
      <LoanDetailsPanel
        currency={calc.currency}
        interestRate={calc.interestRate}
        liquidationPriceValue={calc.liquidationPriceValue}
        maturityRepaymentValue={calc.maturityRepaymentValue}
        originationFeeRate={calc.originationFeeRate}
        isMobile={calc.isMobile}
      />
    </div>
  );
}
